module.exports = __webpack_public_path__ + "static/media/videocam-bg.550cc381.svg";